// PGSS-4572 / PGSS-5094: customer waiting-for-approval tab scoping for categoryValues.

const CUSTOMER_QUOTES_WAITING_STATUS_CODES = new Set(['QUOTE_OUT_FOR_QUOTE_APPROVAL']);

const CUSTOMER_ORDER_WAITING_APPROVAL_STATUS_CODES = new Set([
  'ORDER_OUT_FOR_APPROVAL',
  'ORDER_OUT_FOR_DRAWING_APPROVAL',
  'ORDER_WAITING_FOR_PROOF_APPROVAL',
  'ORDER_OUT_FOR_VAS_PRICE_APPROVAL',
  'ORDER_READY_AND_SEND_FOR_VAS_APPROVAL',
]);

function getStatusCode(status) {
  return status?.system_code ?? status?.code;
}

export function scopeCustomerWaitingApprovalStatuses(statuses, category) {
  if (!Array.isArray(statuses)) {
    return statuses;
  }

  if (category === 'quote_status') {
    return statuses.filter((status) => CUSTOMER_QUOTES_WAITING_STATUS_CODES.has(getStatusCode(status)));
  }

  if (category === 'proof_status') {
    return statuses.filter((status) => CUSTOMER_ORDER_WAITING_APPROVAL_STATUS_CODES.has(getStatusCode(status)));
  }

  return statuses;
}

/** PGSS-5094: customer /orders status filter — exclude waiting-for-approval (mirrors list). */
export function excludeCustomerOrderWaitingApprovalStatuses(statuses, category) {
  if (!Array.isArray(statuses) || category !== 'order_status') {
    return statuses;
  }

  return statuses.filter(
    (status) => !CUSTOMER_ORDER_WAITING_APPROVAL_STATUS_CODES.has(getStatusCode(status))
  );
}
